<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-road-variant
      </v-icon>
        <span class="pl-2">{{ $t('systemSetup.routes.pageTitle') }}</span>
        <v-spacer></v-spacer>
        <v-sheet
            elevation="3"
            rounded="lg"
            class="text-center mx-auto">
            <div class="mx-4">
                <v-radio-group
                v-model="routes_type"
                row
                >
                    <v-radio
                        :label="$t('common.all')"
                        value="all"
                    ></v-radio>
                    <v-radio
                        :label="$t('systemSetup.routes.morningPlural')"
                        value="morning"
                    ></v-radio>
                    <v-radio
                        :label="$t('systemSetup.routes.afternoonPlural')"
                        value="afternoon"
                    ></v-radio>
                </v-radio-group>
            </div>
        </v-sheet>
        <v-spacer></v-spacer>
        <v-menu
            offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn depressed
                :disabled="!activationStore.isActivated"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                color="primary">
                    {{ $t('common.create') }}
                    <v-icon right dark> mdi-plus-thick </v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item
                v-for="(item, index) in menu_items"
                :key="index"
                :value="index"
                @click="createRoute(item.title)"
                >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ menuItemLabel(item.title) }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <activation-tool-tip model="routes"></activation-tool-tip>
      </v-card-title>
      <v-data-table
        item-key="name"
        :loading="isLoading"
        :loading-text="$t('systemSetup.routes.loadingText')"
        :headers="headers"
        :items="displayedRoutes"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('common.search')"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment("LL") }}</small> -
          <small class="text-muted">{{ item.created_at | moment("LT") }}</small>
        </template>
        <template v-slot:item.is_morning="{ item }">
          <v-chip :color="getTimeColor(item.is_morning)" dark>
            {{ getTime(item.is_morning) }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-4" @click="viewRoute(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>{{ $t('common.view') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-4" @click="editStops(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>{{ $t('systemSetup.routes.editStopsTooltip') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="editRoute(item, 'duplicate-new')">
                mdi-content-duplicate
              </v-icon>
            </template>
            <span>{{ $t('systemSetup.routes.duplicateToNew') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="item.is_morning" v-bind="attrs" v-on="on" small class="ml-2" @click="editRoute(item, 'duplicate-reverse')">
                mdi-moon-waning-crescent
              </v-icon>
            </template>
            <span>{{ $t('systemSetup.routes.duplicateAsAfternoon') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="!item.is_morning" v-bind="attrs" v-on="on" small class="ml-2" @click="editRoute(item, 'duplicate-reverse')">
                mdi-white-balance-sunny
              </v-icon>
            </template>
            <span>{{ $t('systemSetup.routes.duplicateAsMorning') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="ml-2" @click="deleteRoute(item, displayedRoutes.indexOf(item))">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t('systemSetup.routes.deleteRouteTooltip') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ActivationToolTip from "@/components/ActivationToolTip";
import { activationStore } from "@/utils/helpers";

export default {
  components: {
    ActivationToolTip,
    activationStore,
  },
  setup() {
    return { activationStore }
  },
  data() {
    return {
        routes_type: "all",
        menu_items: [
          { title: 'Morning', icon: 'mdi-weather-sunset-up' },
          { title: 'Afternoon', icon: 'mdi-weather-sunset-down' },
        ],
      routes: [],
      displayedRoutes: [],
      isLoading: false,
      search: "",
    };
  },
  computed: {
    headers() {
      return [
        { text: "ID", value: "id", align: "start", filterable: false },
        { text: this.$t('common.name'), value: "name" },
        { text: this.$t('systemSetup.routes.headers.stops'), value: "stops_count" },
        { text: this.$t('systemSetup.routes.headers.time'), value: "is_morning" },
        { text: this.$t('systemSetup.routes.headers.createdAt'), value: "created_at" },
        { text: this.$t('common.actions'), value: "actions", sortable: false },
      ];
    },
  },
  watch: {
    routes_type: function (newVal, oldVal) {
      this.filterRoutes(newVal);
    }
  },
  mounted() {
    this.loadRoutes();
  },
  methods: {
    filterRoutes(routes_type)
    {
        this.routes_type = routes_type;
        if(routes_type == "all")
        {
            this.displayedRoutes = this.routes;
        }
        else if(routes_type == "morning")
        {
            this.displayedRoutes = this.routes.filter(route => route.is_morning == 1);
        }
        else if(routes_type == "afternoon")
        {
            this.displayedRoutes = this.routes.filter(route => route.is_morning == 0);
        }
    },
    loadRoutes() {
      this.isLoading = true;
      this.routes = [];
      this.displayedRoutes = [];
      axios
        .get(`/routes/all`)
        .then((response) => {
          this.routes = response.data;
          this.displayedRoutes = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('systemSetup.routes.notifyLoadError'),
            type: 'error'
          });
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getTimeColor(is_morning) {
      return is_morning ? "success" : "warning";
    },
    getTime(is_morning) {
      return is_morning ? this.$t('systemSetup.routes.morning') : this.$t('systemSetup.routes.afternoon');
    },
    menuItemLabel(title) {
      return title === 'Morning' ? this.$t('systemSetup.routes.morning') : this.$t('systemSetup.routes.afternoon');
    },
    createRoute(title) {
      this.$swal
        .fire({
          title: this.$t('systemSetup.routes.createRouteNamePrompt', { type: this.menuItemLabel(title) }),
          input: "text",
          inputPlaceholder: this.$t('systemSetup.routes.newRoutePlaceholder'),
          showCancelButton: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            const value = result.value.trim();
            this.$router.push({
              name: "create-route",
              params: { route_name: value ? value : "Untitled", route_type: title },
            });
          }
        });
    },
    viewRoute(route) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route.id},
      });
    },
    editRoute(route, action = "επεξεργασία") {
      this.$swal
        .fire({
          title: this.$t('systemSetup.routes.enterRouteNamePrompt'),
          input: "text",
          inputValue: route.name,
          showCancelButton: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            const value = result.value.trim();
            this.$router.push({
              name: "edit-route",
              params: { route_id: route.id, new_route_name: value ? value : "Untitled", action: action },
            });
          }
        });

    },
    editStops(route) {
      axios
        .get(`/routes/${route.id}/stop-edit-impact`)
        .then((response) => {
          const impact = response.data;
          if (impact.editable === false) {
            this.$swal(
              this.$t('systemSetup.routes.editStopsBlockedTitle'),
              this.stopEditErrorMessage(impact.blocked_reason),
              "warning"
            );
            return;
          }
          const students = (impact.stops || []).reduce(
            (total, stop) => total + stop.pickup_students + stop.drop_off_students,
            0
          );
          if (impact.trips_count > 0 || students > 0) {
            this.$swal
              .fire({
                title: this.$t('systemSetup.routes.editStopsImpactTitle'),
                text: this.$t('systemSetup.routes.editStopsImpactText', {
                  trips: impact.trips_count,
                  students: students,
                }),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: this.$t('systemSetup.routes.editStopsImpactConfirmButton'),
                cancelButtonText: this.$t('common.cancel'),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.openStopEditor(route);
                }
              });
            return;
          }
          this.openStopEditor(route);
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('systemSetup.routes.notifyStopEditImpactError'),
            type: 'error'
          });
          this.$swal(
            this.$t('common.error'),
            this.stopEditErrorMessage(
              error.response && error.response.data && error.response.data.code
            ),
            "error"
          );
        });
    },
    stopEditErrorMessage(code) {
      const key = `systemSetup.routes.stopEditErrors.${code}`;
      return this.$te(key) ? this.$t(key) : this.$t('systemSetup.routes.stopEditErrors.unknown');
    },
    openStopEditor(route) {
      this.$router.push({
        name: "edit-route",
        params: { route_id: route.id, new_route_name: route.name, action: "edit-in-place" },
      });
    },
    deleteRoute(route, index) {
      this.$swal
        .fire({
          title: this.$t('systemSetup.routes.deleteConfirmTitle'),
          text: this.$t('systemSetup.routes.deleteConfirmText', { name: route.name }),
          icon: "error",
          showCancelButton: true,
          confirmButtonText: this.$t('systemSetup.routes.confirmDeleteButton'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteRouteServer(route.id, index);
          }
        });
    },
    deleteRouteServer(route_id, index) {
      axios
        .delete(`/routes/${route_id}`)
        .then((response) => {
          let idx = this.routes.findIndex((route) => route.id == route_id);
          this.routes.splice(idx, 1);
          this.filterRoutes(this.routes_type);
          this.$notify({
            title: this.$t('common.success'),
            text: this.$t('systemSetup.routes.notifyDeleted'),
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('systemSetup.routes.notifyDeleteError'),
            type: 'error'
          });
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          //this.isDeleting = false;
        });
    },
  },
};
</script>
